import React, { PropsWithChildren, useState } from "react";
import { Button } from "../Actions";

type Props = {
  textToCopy: string;
  isCopyAll?: boolean;
  buttonLabel?: string;
};
export const CopyButton: React.FC<PropsWithChildren<Props>> = ({
  textToCopy,
  children,
  isCopyAll,
  buttonLabel
}) => {
  const [showSuccessText, setShowSuccessText] = useState(false);

  const handleSuccessCopy = (textToCopy: string) => {
    navigator.clipboard.writeText(textToCopy);
    setShowSuccessText(true);
    setTimeout(() => {
      setShowSuccessText(false);
    }, 1000);
  };

  if (isCopyAll)
    return (
      <Button
        className="transition-all"
        modifier="secondary"
        analyticsProperty="Copy All Links"
        onClick={() => handleSuccessCopy(textToCopy)}>
        {showSuccessText ? "Copied" : children}
      </Button>
    );
  return (
    <button
      className="flex mono2 gap-6 p-4 color-coinage-blue border-coinage-purple bg-coinage-offWhite text-coinage-blue rounded-md border-[1px] justify-between items-center"
      onClick={() => handleSuccessCopy(textToCopy)}>
      <span>{buttonLabel}</span>
      <span className="btn">{showSuccessText ? "Copied" : children}</span>
    </button>
  );
};
